'use strict'

import en from './en'

const allStrings = {
  en: en
}

export default allStrings
